!(function (t) {
  t("#filter-sidebar") &&
    History.Adapter.bind(window, "statechange", function () {
      History.getState();
      if (!a.isSidebarAjaxClick) {
        a.sidebarParams();
        var e = a.sidebarCreateUrl();
        a.sidebarGetContent(e);
      }
      a.isSidebarAjaxClick = !1;
    }),
    window.use_color_swatch &&
      (t(".swatch :radio").change(function () {
        var e = t(this).closest(".swatch").attr("data-option-index"),
          i = t(this).val();
        t(this)
          .closest("form")
          .find(".single-option-selector")
          .eq(e)
          .val(i)
          .trigger("change");
      }),
      (Shopify.optionsMap = {}),
      (Shopify.updateOptionsInSelector = function (i) {
        switch (i) {
          case 0:
            var a = "root",
              o = t(".single-option-selector:eq(0)");
            break;
          case 1:
            var a = t(".single-option-selector:eq(0)").val(),
              o = t(".single-option-selector:eq(1)");
            break;
          case 2:
            var a = t(".single-option-selector:eq(0)").val();
            a += " / " + e(".single-option-selector:eq(1)").val();
            var o = t(".single-option-selector:eq(2)");
        }
        var r = o.val();
        o.empty();
        for (var n = Shopify.optionsMap[a], s = 0; s < n.length; s++) {
          var c = n[s],
            d = t("<option></option>").val(c).html(c);
          o.append(d);
        }
        t('.swatch[data-option-index="' + i + '"] .swatch-element').each(
          function () {
            -1 !== t.inArray(t(this).attr("data-value"), n)
              ? t(this)
                  .removeClass("soldout")
                  .show()
                  .find(":radio")
                  .removeAttr("disabled", "disabled")
                  .removeAttr("checked")
              : t(this)
                  .addClass("soldout")
                  .hide()
                  .find(":radio")
                  .removeAttr("checked")
                  .attr("disabled", "disabled");
          }
        ),
          -1 !== t.inArray(r, n) && o.val(r),
          o.trigger("change");
      }),
      (Shopify.linkOptionSelectors = function (e) {
        for (var i = 0; i < e.variants.length; i++) {
          var a = e.variants[i];
          if (a.available) {
            if (
              ((Shopify.optionsMap.root = Shopify.optionsMap.root || []),
              Shopify.optionsMap.root.push(a.option1),
              (Shopify.optionsMap.root = Shopify.uniq(Shopify.optionsMap.root)),
              e.options.length > 1)
            ) {
              var o = a.option1;
              (Shopify.optionsMap[o] = Shopify.optionsMap[o] || []),
                Shopify.optionsMap[o].push(a.option2),
                (Shopify.optionsMap[o] = Shopify.uniq(Shopify.optionsMap[o]));
            }
            if (3 === e.options.length) {
              var o = a.option1 + " / " + a.option2;
              (Shopify.optionsMap[o] = Shopify.optionsMap[o] || []),
                Shopify.optionsMap[o].push(a.option3),
                (Shopify.optionsMap[o] = Shopify.uniq(Shopify.optionsMap[o]));
            }
          }
        }
        Shopify.updateOptionsInSelector(0),
          e.options.length > 1 && Shopify.updateOptionsInSelector(1),
          3 === e.options.length && Shopify.updateOptionsInSelector(2),
          t(".single-option-selector:eq(0)").change(function () {
            return (
              Shopify.updateOptionsInSelector(1),
              3 === e.options.length && Shopify.updateOptionsInSelector(2),
              !0
            );
          }),
          t(".single-option-selector:eq(1)").change(function () {
            return (
              3 === e.options.length && Shopify.updateOptionsInSelector(2), !0
            );
          });
      })),
    t(document).ready(function () {
      a.go();
    }),
    t(window).resize(function () {
      a.goResizeImage();
    });
  var a = {
    atTimeout: null,
    isSidebarAjaxClick: !1,
    go: function () {
      this.goResizeImage(),
        this.goCloudzoom(),
        this.goSidebar(),
        this.goQuickView(),
        this.goScrollTop(),
        this.goDropDownCart(),
        this.goAddToCart(),
        this.goBox(),
        this.goProductAddToCart(),
        this.goWishlist(),
        this.goProductWishlist(),
        this.goRemoveWishlist();
    },
    sidebarTag: function () {
      t(".sidebar-tag a, .sidebar-tag label").click(function (e) {
        var i = [];
        if (
          (Shopify.queryParams.constraint &&
            (i = Shopify.queryParams.constraint.split("+")),
          !window.enable_sidebar_multiple_choice &&
            !t(this).prev().is(":checked"))
        ) {
          var o = t(this).parents(".sidebar-tag").find("input:checked");
          if (o.length > 0) {
            var r = o.val();
            if (r) {
              var n = i.indexOf(r);
              n >= 0 && i.splice(n, 1);
            }
          }
        }
        var r = t(this).prev().val();
        if (r) {
          var n = i.indexOf(r);
          n >= 0 ? i.splice(n, 1) : i.push(r);
        }
        i.length
          ? (Shopify.queryParams.constraint = i.join("+"))
          : delete Shopify.queryParams.constraint,
          a.sidebarAjaxClick(),
          e.preventDefault();
      });
    },
    sidebarMapEvents: function () {
      a.sidebarTag();
    },
    checkItemsInDropdownCart: function () {
      t("#dropdown-cart .cart-list").children().length > 0
        ? (t("#dropdown-cart .cart-empty").hide(),
          t("#dropdown-cart .mini_cart_header").show())
        : (t("#dropdown-cart .mini_cart_header").hide(),
          t("#dropdown-cart .cart-empty").show());
    },
    goDropDownCart: function () {
      a.checkItemsInDropdownCart(),
        t("#dropdown-cart .cart-empty a").click(function () {
          t("#dropdown-cart").slideUp("fast");
        }),
        t("#dropdown-cart .btn-remove").click(function (e) {
          e.preventDefault();
          var i = t(this).parents(".item").attr("id");
          (i = i.match(/\d+/g)),
            Shopify.removeItem(i, function (e) {
              a.doUpdateDropdownCart(e);
            });
        });
    },
    closeDropdownCart: function () {
      t("#dropdown-cart").is(":visible") && t("#dropdown-cart").slideUp("fast");
    },
    sidebarMapData: function (e) {
      var i = t(".col-main .products-grid");
      0 == i.length && (i = t(".col-main .product-list"));
      var a = t(e).find(".col-main .products-grid");
      0 == a.length && (a = t(e).find(".col-main .product-list")),
        a.length > 0 &&
          a.hasClass("products-grid") &&
          window.product_image_resize &&
          a
            .find("img")
            .fakecrop({
              fill: window.images_size.is_crop,
              widthSelector: ".grid-item .product-image",
              ratioWrapper: window.images_size,
            }),
        i.replaceWith(a);
      var o = t(".page-header"),
        r = t(e).find(".page-header");
      o.find("h2").text() != r.find("h2").text() &&
        (o.find("h2").replaceWith(r.find("h2")),
        o.find(".rte").length
          ? r.find(".rte").length
            ? o.find(".rte").replaceWith(r.find(".rte"))
            : o.find(".rte").hide()
          : r.find(".rte").length && o.find("h2").after(r.find(".rte"))),
        t(".refined-widgets").replaceWith(t(e).find(".refined-widgets")),
        t(".sidebar-block").replaceWith(t(e).find(".sidebar-block"));
    },
    sidebarCreateUrl: function (e) {
      var i = t.param(Shopify.queryParams).replace(/%2B/g, "+");
      return e ? ("" != i ? e + "?" + i : e) : location.pathname + "?" + i;
    },
    sidebarAjaxClick: function (e) {
      delete Shopify.queryParams.page;
      var i = a.sidebarCreateUrl(e);
      (a.isSidebarAjaxClick = !0),
        History.pushState({ param: Shopify.queryParams }, i, i),
        a.sidebarGetContent(i);
    },
    sidebarGetContent: function (e) {
      t.ajax({
        type: "get",
        url: e,
        beforeSend: function () {
          a.showLoading();
        },
        success: function (e) {
          a.sidebarMapData(e),
            a.goQuickView(),
            a.sidebarTag(),
            a.hideLoading(),
            a.goAddToCart(),
            a.goWishlist();
        },
        error: function (e, i) {
          a.hideLoading(),
            t(".loading").hide(),
            t(".ajax-error-message").text(
              t.parseJSON(e.responseText).description
            ),
            a.showBox(".ajax-error-cbox");
        },
      });
    },
    sidebarParams: function () {
      if (((Shopify.queryParams = {}), location.search.length))
        for (
          var e, i = 0, a = location.search.substr(1).split("&");
          i < a.length;
          i++
        )
          (e = a[i].split("=")),
            t.length > 1 &&
              (Shopify.queryParams[
                decodeURIComponent(e[0])
              ] = decodeURIComponent(e[1]));
    },
    goSidebar: function () {
      t("#filter-sidebar").length > 0 &&
        (a.sidebarParams(), a.sidebarMapEvents());
    },
    goWishlist: function () {
      t(".grid-item button.wishlist").click(function (e) {
        e.preventDefault();
        var i = t(this).parent();
        i.parents(".grid-item");
        t.ajax({
          type: "POST",
          url: "/contact",
          data: i.serialize(),
          beforeSend: function () {
            a.showLoading();
          },
          success: function (e) {
            a.hideLoading(),
              i.html(
                '<a class="wishlist" href="/pages/wish-list" title="Go to wishlist"><span class="icon"></span><span>Go to wishlist</span></a>'
              ),
              t(".ajax-success-cbox").find(".show-wishlist").show(),
              t(".ajax-success-cbox").find(".show-cart").hide(),
              a.showBox(".ajax-success-cbox");
          },
          error: function (e, i) {
            a.hideLoading(),
              t(".loading").hide(),
              t(".ajax-error-message").text(
                t.parseJSON(e.responseText).description
              ),
              a.showBox(".ajax-error-cbox");
          },
        });
      });
    },
    goProductWishlist: function () {
      t(".product button.wishlist").click(function (e) {
        e.preventDefault();
        var i = t(this).parent();
        i.parents(".grid-item");
        t.ajax({
          type: "POST",
          url: "/contact",
          data: i.serialize(),
          beforeSend: function () {
            a.showLoading();
          },
          success: function (e) {
            a.hideLoading(),
              i.html(
                '<a class="wishlist" href="/pages/wish-list" title="Go to wishlist"><span class="icon"></span><span>Go to wishlist</span></a>'
              ),
              t(".ajax-success-cbox").find(".show-wishlist").show(),
              t(".ajax-success-cbox").find(".show-cart").hide(),
              a.showBox(".ajax-success-cbox");
          },
          error: function (e, i) {
            a.hideLoading(),
              t(".loading").hide(),
              t(".ajax-error-message").text(
                t.parseJSON(e.responseText).description
              ),
              a.showBox(".ajax-error-cbox");
          },
        });
      });
    },
    goRemoveWishlist: function () {
      t(".btn-remove-wishlist").click(function (e) {
        var i = t(this).parents("tr"),
          o = i.find(".tag-id").val(),
          r = jQuery("#remove-wishlist-form");
        r.find("input[name='contact[tags]']").val("x" + o),
          t.ajax({
            type: "POST",
            url: "/contact",
            data: r.serialize(),
            beforeSend: function () {
              a.showLoading();
            },
            success: function (e) {
              a.hideLoading(), i.fadeOut(1e3);
            },
            error: function (e, i) {
              a.hideLoading(),
                t(".loading-modal").hide(),
                t(".ajax-error-message").text(
                  t.parseJSON(e.responseText).description
                ),
                a.showModal(".ajax-error-cbox");
            },
          });
      });
    },
    goResizeImage: function () {
      window.product_image_resize &&
        t(".product-image img").fakecrop({
          fill: window.images_size.is_crop,
          widthSelector: ".grid-item .product-image",
          ratioWrapper: window.images_size,
        });
    },
    showBox: function (e) {
      t(e).fadeIn(500),
        (a.atTimeout = setTimeout(function () {
          t(e).fadeOut(500);
        }, 5e3));
    },
    goBox: function () {
      t(".continue-shopping").click(function () {
        clearTimeout(a.atTimeout), t(".ajax-success-cbox").fadeOut(500);
      }),
        t(".close-cbox").click(function () {
          clearTimeout(a.atTimeout), t(".ajax-success-cbox").fadeOut(500);
        });
    },
    goCloudzoom: function () {
      t("#product-featured-none").length > 0 &&
        (t("#product-featured-none").elevateZoom({
          gallery: "zt_list_product",
          cursor: "pointer",
          galleryActiveClass: "active",
          imageCrossfade: !0,
          scrollZoom: !0,
          onImageSwapComplete: function () {
            t(".gallery-images div").hide();
          },
          loadingIcon: window.loading_url,
        }),
        t("#product-featured-none").bind("click", function (e) {
          var i = t("#product-featured-none").data("elevateZoom");
          return t.fancybox(i.getGalleryList()), !1;
        }));
    },
    goScrollTop: function () {
      t("#back-top").click(function () {
        return t("body,html").animate({ scrollTop: 0 }, 400), !1;
      });
    },
    goProductAddToCart: function () {
      t("#product-add-to-cart").length > 0 &&
        t("#product-add-to-cart").click(function (e) {
          if ((e.preventDefault(), "disabled" != t(this).attr("disabled")))
            if (window.ajax_cart) {
              var i = t("#add-to-cart-form select[name=id]").val();
              i || (i = t("#add-to-cart-form input[name=id]").val());
              var o = t("#add-to-cart-form input[name=quantity]").val();
              o || (o = 1);
              var r = t(".product-title h2").text();
              a.doAjaxAddToCart(i, o, r);
            } else t(this).closest("form").submit();
          return !1;
        });
    },
    goAddToCart: function () {
      t(".add-to-cart-btn").length > 0 &&
        t(".add-to-cart-btn").click(function (e) {
          if ((e.preventDefault(), "disabled" != t(this).attr("disabled"))) {
            var i = t(this).parents(".product-item"),
              o = t(i).attr("id");
            if (((o = o.match(/\d+/g)), window.ajax_cart)) {
              var r = t("#product-actions-" + o + " select[name=id]").val();
              r || (r = t("#product-actions-" + o + " input[name=id]").val());
              var n = t(
                "#product-actions-" + o + " input[name=quantity]"
              ).val();
              n || (n = 1);
              var s = t(i).find(".product-title").text();
              a.doAjaxAddToCart(r, n, s);
            } else t("#product-actions-" + o).submit();
          }
          return !1;
        });
    },
    showLoading: function () {
      t(".loading").show();
    },
    hideLoading: function () {
      t(".loading").hide();
    },
    doAjaxAddToCart: function (e, i, o, r) {
      t.ajax({
        type: "post",
        url: "/cart/add.js",
        data: "quantity=" + i + "&id=" + e,
        dataType: "json",
        beforeSend: function () {
          a.showLoading();
        },
        success: function (e) {
          a.hideLoading(),
            t(".ajax-success-cbox").find(".ajax-product-title").text(o),
            t(".ajax-success-cbox").find(".show-wishlist").hide(),
            t(".ajax-success-cbox").find(".show-cart").show(),
            a.showBox(".ajax-success-cbox"),
            a.updateDropdownCart();
            window.vueHeader.updateCartCount(i);
            window.vueHeader.loadCartObject();
        },
        error: function (e, i) {
          a.hideLoading(),
            t(".ajax-error-message").text(
              t.parseJSON(e.responseText).description
            ),
            a.showBox(".ajax-error-cbox");
        },
      });
    },
    goQuickView: function () {
      jQuery(".quickview-button a").click(function () {
        var e = jQuery(this).attr("id");
        return (
          Shopify.getProduct(e, function (e) {
            var i = jQuery("#quickview-popup").html();
            jQuery(".product-quickview").html(i);
            var t = jQuery(".product-quickview"),
              o = e.description.replace(/(<([^>]+)>)/gi, "");
            if (
              ((o = o.split(" ").splice(0, 20).join(" ") + "..."),
              t.find(".product-title a").text(e.title),
              t.find(".product-title a").attr("href", e.url),
              t.find(".product-vendor span").length > 0 &&
                t.find(".product-vendor span").text(e.vendor),
              t.find(".product-type span").length > 0 &&
                t.find(".product-type span").text(e.type),
              t.find(".product-inventory span").length > 0)
            ) {
              var n = e.variants[0].inventory_quantity;
              n > 0
                ? null != e.variants[0].inventory_management
                  ? t.find(".product-inventory span").text(n + " in stock")
                  : t.find(".product-inventory span").text("Many in stock")
                : t.find(".product-inventory span").text("Out of stock");
            }
            t.find(".product-description").text(o),
              t
                .find(".price")
                .html(Shopify.formatMoney(e.price, window.money_format)),
              t.find(".product-item").attr("id", "product-" + e.id),
              t.find(".variants").attr("id", "product-actions-" + e.id),
              t.find(".variants select").attr("id", "product-select-" + e.id),
              e.compare_at_price > e.price
                ? (t
                    .find(".compare-price")
                    .html(
                      Shopify.formatMoney(
                        e.compare_at_price_max,
                        window.money_format
                      )
                    )
                    .show(),
                  t.find(".price").addClass("on-sale"))
                : (t.find(".compare-price").html(""),
                  t.find(".price").removeClass("on-sale")),
              e.available
                ? (t
                    .find(".total-price span")
                    .html(Shopify.formatMoney(e.price, window.money_format)),
                  window.use_color_swatch
                    ? a.createQuickViewVariantsSwatch(e, t)
                    : a.createQuickViewVariants(e, t))
                : (t
                    .find(
                      "select, input, .total-price, .dec, .inc, .variants label"
                    )
                    .remove(),
                  t
                    .find(".add-to-cart-btn")
                    .text("Unavailable")
                    .addClass("disabled")
                    .attr("disabled", "disabled")),
              t.find(".button").on("click", function () {
                var e = t.find(".quantity").val();
                "+" == jQuery(this).text()
                  ? (r = parseInt(e) + 1)
                  : e > 1 && (r = parseInt(e) - 1),
                  t.find(".quantity").val(r),
                  t.find(".total-price").length > 0 &&
                    a.updatePricingQuickview();
              }),
              window.show_multiple_currencies &&
                Currency.convertAll(
                  window.shop_currency,
                  jQuery("#currencies").val(),
                  "span.money",
                  "money_format"
                ),
              a.loadQuickViewSlider(e, t),
              a.goQuickviewAddToCart(),
              jQuery(".product-quickview").fadeIn(500),
              jQuery(".product-quickview .total-price").length > 0 &&
                jQuery(".product-quickview input[name=quantity]").on(
                  "change",
                  a.updatePricingQuickview
                );
          }),
          !1
        );
      }),
        jQuery(".product-quickview .overlay, .close-popup").live(
          "click",
          function () {
            return a.closeQuickViewPopup(), !1;
          }
        );
    },
    updatePricingQuickview: function () {
      var e = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g,
        i = jQuery(".product-quickview .price").text().match(e);
      if (
        (i ||
          ((e = /([0-9]+[.|,][0-9]+)/g),
          (i = jQuery(".product-quickview .price").text().match(e))),
        i)
      ) {
        var t = i[0],
          a = t.replace(/[.|,]/g, ""),
          o = parseInt(jQuery(".product-quickview input[name=quantity]").val()),
          n = a * o,
          s = Shopify.formatMoney(n, window.money_format);
        s = s.match(e)[0];
        var c = new RegExp(r, "g"),
          d = jQuery(".product-quickview .price").html().replace(c, s);
        jQuery(".product-quickview .total-price span").html(d);
      }
    },
    goQuickviewAddToCart: function () {
      jQuery(".product-quickview .add-to-cart-btn").length > 0 &&
        jQuery(".product-quickview .add-to-cart-btn").click(function () {
          var e = jQuery(".product-quickview select[name=id]").val();
          e || (e = jQuery(".product-quickview input[name=id]").val());
          var i = jQuery(".product-quickview input[name=quantity]").val();
          i || (i = 1);
          var t = jQuery(".product-quickview .product-title a").text(),
            o = jQuery(".product-quickview .quickview-featured-image img").attr(
              "src"
            );
          a.doAjaxAddToCart(e, i, t, o), a.closeQuickViewPopup();
        });
    },
    updateDropdownCart: function () {
      Shopify.getCart(function (e) {
        a.doUpdateDropdownCart(e);
      });
    },
    doUpdateDropdownCart: function (e) {
      t("#cart-count").text(e.item_count);
    },
    convertToSlug: function (e) {
      return t
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
    },
    updateDropdownCart: function () {
      Shopify.getCart(function (e) {
        a.doUpdateDropdownCart(e);
      });
    },
    doUpdateDropdownCart: function (e) {
      var i =
        '<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-inner"><a href="javascript:void(0)" title="Remove This Item" class="btn-remove">X</a><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="cart-collateral">{QUANTITY} x <span class="price">{PRICE}</span></div></div></li>';
      if (
        (t("#cart-count").text(e.item_count),
        t("#dropdown-cart .summary .price").html(
          Shopify.formatMoney(e.total_price, window.money_format)
        ),
        t(".top-cart .price").html(
          Shopify.formatMoney(e.total_price, window.money_format)
        ),
        t("#dropdown-cart .cart-list").html(""),
        e.item_count > 0)
      ) {
        for (var o = 0; o < e.items.length; o++) {
          var r = i;
          (r = r.replace(/\{ID\}/g, e.items[o].id)),
            (r = r.replace(/\{URL\}/g, e.items[o].url)),
            (r = r.replace(/\{TITLE\}/g, e.items[o].title)),
            (r = r.replace(/\{QUANTITY\}/g, e.items[o].quantity)),
            (r = r.replace(
              /\{IMAGE\}/g,
              Shopify.resizeImage(e.items[o].image, "small")
            )),
            (r = r.replace(
              /\{PRICE\}/g,
              Shopify.formatMoney(e.items[o].price, window.money_format)
            )),
            t("#dropdown-cart .cart-list").append(r);
        }
        t("#dropdown-cart .btn-remove").click(function (e) {
          e.preventDefault();
          var i = t(this).parents(".item").attr("id");
          (i = i.match(/\d+/g)),
            Shopify.removeItem(i, function (e) {
              a.doUpdateDropdownCart(e);
            });
        }),
          a.checkNeedToConvertCurrency() &&
            Currency.convertAll(
              window.shop_currency,
              jQuery("#currencies").val(),
              "#dropdown-cart span.money",
              "money_format"
            );
      }
      a.checkItemsInDropdownCart();
    },
    checkNeedToConvertCurrency: function () {
      return (
        window.show_multiple_currencies &&
        Currency.currentCurrency != shopCurrency
      );
    },
    loadQuickViewSlider: function (e, t) {
      var o = Shopify.resizeImage(e.featured_image, "grande");
      if (
        (t
          .find(".quickview-featured-image")
          .append(
            '<a href="' +
              e.url +
              '"><img src="' +
              o +
              '" title="' +
              e.title +
              '"/><div style="height: 100%; width: 100%; top:0; left:0 z-index: 2000; position: absolute; display: none; background: url(' +
              window.loading_url +
              ') 50% 50% no-repeat;"></div></a>'
          ),
        e.images.length > 2)
      ) {
        var r = t.find(".more-view ul");
        for (i in e.images) {
          var n = Shopify.resizeImage(e.images[i], "grande"),
            s = Shopify.resizeImage(e.images[i], "compact"),
            c =
              '<li><a href="javascript:void(0)" data-image="' +
              n +
              '"><img src="' +
              s +
              '"  /></a></li>';
          r.append(c);
        }
        r.find("a").click(function () {
          var e = t.find(".quickview-featured-image img"),
            i = t.find(".quickview-featured-image div");
          e.attr("src") != jQuery(this).attr("data-image") &&
            (e.attr("src", jQuery(this).attr("data-image")),
            i.show(),
            e.load(function (e) {
              i.hide(), jQuery(this).unbind("load"), i.hide();
            }));
        }),
          r.hasClass("quickview-more-views-owlslider")
            ? a.goQuickViewCarousel(r)
            : a.goQuickViewVerticalMoreview(r);
      } else
        t.find(".quickview-more-views").remove(),
          t.find(".quickview-more-view-wrapper-jcarousel").remove();
    },
    goQuickViewCarousel: function (e) {
      e &&
        e
          .owlCarousel({
            navigation: !0,
            navigationText: [
              '<i class="fa fa-angle-left"></i>',
              '<i class="fa fa-angle-right"></i>',
            ],
            pagination: !1,
            items: 3,
            itemsDesktop: [1199, 3],
            itemsDesktopSmall: [979, 3],
            itemsTablet: [768, 3],
            itemsTabletSmall: [540, 3],
            itemsMobile: [360, 3],
          })
          .css("visibility", "visible");
    },
    goQuickViewVerticalMoreview: function (e) {
      e &&
        (e.jcarousel({ vertical: !0 }),
        jQuery(".product-img-box").addClass("has-jcarousel"),
        jQuery(".more-view-wrapper").css("visibility", "visible"));
    },
    convertToSlug: function (e) {
      return e
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
    },
    createQuickViewVariantsSwatch: function (e, i) {
      if (e.variants.length > 1) {
        for (var t = 0; t < e.variants.length; t++) {
          var a = e.variants[t],
            o = '<option value="' + a.id + '">' + a.title + "</option>";
          i.find("form.variants > select").append(o);
        }
        new Shopify.OptionSelectors("product-select-" + e.id, {
          product: e,
          onVariantSelected: selectCallbackQuickview,
        });
        for (
          var r = window.file_url.substring(
              0,
              window.file_url.lastIndexOf("?")
            ),
            n = window.asset_url.substring(
              0,
              window.asset_url.lastIndexOf("?")
            ),
            s = "",
            t = 0;
          t < e.options.length;
          t++
        ) {
          (s += '<div class="swatch clearfix" data-option-index="' + t + '">'),
            (s += '<div class="header">' + e.options[t].name + "</div>");
          var c = !1;
          /Color|Colour/i.test(e.options[t].name) && (c = !0);
          for (var d = new Array(), l = 0; l < e.variants.length; l++) {
            var a = e.variants[l],
              p = a.options[t],
              u = this.convertToSlug(p),
              f = "swatch-" + t + "-" + u;
            d.indexOf(p) < 0 &&
              ((s +=
                '<div data-value="' +
                p +
                '" class="swatch-element ' +
                (c ? "color" : "") +
                u +
                (a.available ? " available " : " soldout ") +
                '">'),
              (s +=
                '<input id="' +
                f +
                '" type="radio" name="option-' +
                t +
                '" value="' +
                p +
                '" ' +
                (0 == l ? " checked " : "") +
                (a.available ? "" : " disabled") +
                " />"),
              (s += c
                ? '<label for="' +
                  f +
                  '" style="background-color: ' +
                  u +
                  "; background-image: url(" +
                  r +
                  u +
                  '.png)"><img class="crossed-out" src="' +
                  n +
                  'soldout.png" /></label>'
                : '<label for="' +
                  f +
                  '">' +
                  p +
                  '<img class="crossed-out" src="' +
                  n +
                  'soldout.png" /></label>'),
              (s += "</div>"),
              a.available &&
                jQuery(
                  '.product-quickview .swatch[data-option-index="' +
                    t +
                    '"] .' +
                    u
                )
                  .removeClass("soldout")
                  .addClass("available")
                  .find(":radio")
                  .removeAttr("disabled"),
              d.push(p));
          }
          s += "</div>";
        }
        i.find("form.variants > select").after(s),
          i.find(".swatch :radio").change(function () {
            var e = jQuery(this).closest(".swatch").attr("data-option-index"),
              i = jQuery(this).val();
            jQuery(this)
              .closest("form")
              .find(".single-option-selector")
              .eq(e)
              .val(i)
              .trigger("change");
          }),
          e.available &&
            ((Shopify.optionsMap = {}), Shopify.linkOptionSelectors(e));
      } else {
        i.find("form.variants > select").remove();
        var h =
          '<input type="hidden" name="id" value="' + e.variants[0].id + '">';
        i.find("form.variants").append(h);
      }
    },
    createQuickViewVariants: function (e, i) {
      if (e.variants.length > 1) {
        for (var t = 0; t < e.variants.length; t++) {
          var a = e.variants[r],
            o = '<option value="' + a.id + '">' + a.title + "</option>";
          i.find("form.variants > select").append(o);
        }
        new Shopify.OptionSelectors("product-select-" + e.id, {
          product: e,
          onVariantSelected: selectCallbackQuickview,
        }),
          jQuery(".product-quickview .single-option-selector").selectize(),
          jQuery(".product-quickview .selectize-input input").attr(
            "disabled",
            "disabled"
          ),
          1 == e.options.length &&
            jQuery(".selector-wrapper:eq(0)").prepend(
              "<label>" + e.options[0].name + "</label>"
            ),
          i.find("form.variants .selector-wrapper label").each(function (i, t) {
            jQuery(this).html(e.options[i].name);
          });
      } else {
        i.find("form.variants > select").remove();
        var n =
          '<input type="hidden" name="id" value="' + e.variants[0].id + '">';
        i.find("form.variants").append(n);
      }
    },
    closeQuickViewPopup: function () {
      jQuery(".product-quickview").fadeOut(500);
    },
  };
})(jQuery);
